import LogRocket from "logrocket";
import { AuthUser } from "react-ai-platform-auth";

import { useAuthContext } from "../authHelper";
import featureFlags from "../featureFlags";
import { updateClientKey, updateOrganizationId } from "../utilities/featureFlagUtils";

function _addUserToLogRocketSession(user: AuthUser | null): void {
  if (!user) {
    return;
  }
  if (featureFlags.isLogrocketEnabled) {
    LogRocket.identify(user.email);
  }
}

function _addUserToSplitIOSession(user: AuthUser | null): void {
  if (!user) {
    return;
  }
  const { id: userId, activeMembership } = user;
  if (userId) {
    updateClientKey(userId);
  }
  updateOrganizationId(activeMembership.id);
}

function useAuthenticatedUser(): AuthUser | null {
  const { user } = useAuthContext();

  _addUserToLogRocketSession(user);
  _addUserToSplitIOSession(user);

  return user || null;
}

export default useAuthenticatedUser;
